// extracted by mini-css-extract-plugin
module.exports = {"vfContainer":"e_9r","followed":"e_-r","followedIcon":"e_as","follow":"e_bs","followIcon":"e_cs"};